type RGBA = { r: number; g: number; b: number; a: number };

type LayoutGridUnion =
  | {
      pattern: 'GRID';
      sectionSize?: number;
      visible?: boolean;
      color: RGBA;
    }
  | {
      pattern: 'COLUMNS' | 'ROWS';
      alignment: string;
      count?: number;
      gutterSize?: number;
      visible?: boolean;
      color: RGBA;
      offset?: number;
      sectionSize?: number;
    };

export const getLayerLayoutGrids = (layer: {
  layoutGrids?: LayoutGridUnion[];
}) => {
  const layoutGrids = layer.layoutGrids;

  if (!layoutGrids) {
    return [];
  }

  return layoutGrids.map((layoutGrid: any) => {
    switch (layoutGrid.pattern) {
      case 'GRID': {
        return {
          pattern: layoutGrid.pattern,
          sectionSize: layoutGrid.sectionSize,
          visible: layoutGrid.visible,
          color: {
            r: layoutGrid.color.r,
            g: layoutGrid.color.g,
            b: layoutGrid.color.b,
            a: Number(layoutGrid.color.a.toFixed(2)),
          },
        };
      }
      case 'COLUMNS':
      case 'ROWS': {
        const row: Record<string, unknown> = {
          alignment: layoutGrid.alignment,
          count: layoutGrid.count,
          gutterSize: layoutGrid.gutterSize,
          pattern: layoutGrid.pattern,
          visible: layoutGrid.visible,
          color: {
            r: layoutGrid.color.r,
            g: layoutGrid.color.g,
            b: layoutGrid.color.b,
            a: Number(layoutGrid.color.a.toFixed(2)),
          },
        };

        if (layoutGrid.alignment !== 'CENTER') {
          row.offset = layoutGrid.offset;
        }

        if (layoutGrid.alignment !== 'STRETCH') {
          row.sectionSize = layoutGrid.sectionSize;
        }

        return row;
      }
    }
  });
};
